import './vienna2/style';
import FormStructure from './vienna2/form_structure';

export default FormStructure;